<template>
    <div class="edit">
        <KaryawanList v-bind:class="{hidesection: !iskaryawanlist}" ref="listkaryawan"
                      v-on:showcreatestaff="showcreatestaff" v-bind:datakaryawanlist="datakaryawanlist"
                      v-on:showdetail="showdetail" v-on:showimporabsen="showdataimporabsen"
                      v-on:showrekapabsen="showdatarekapabsen" v-bind:datarekap="datarekap"
                      :periode_absen="periode_absen"
        />
        <CreateStaff v-if="iscreatestaff" v-bind:datacreatestaff="datacreatestaff"
                     v-on:showdataakun="showdatastaf" v-on:showkaryawanlist="showlist"/>
        <DataStaff v-if="isdatastaff" v-bind:datadatastaff="datastaffakun"
                   v-on:showdatapekerjaan="showdatapekerjaan" v-on:showcreatestaff="showcreatestaff"
                   v-on:showdatagaji="showdatagaji"/>
        <DataPekerjaan v-bind:class="{hidesection: !isdatapekerjaan}" v-bind:datapekerjaan="datapekerjaandata"
                       v-on:showdatagaji="showdatagaji" v-on:showdataakun="showdatastaf" ref="datapekerjaanref"/>
        <DataGaji v-bind:class="{hidesection: !isdatagaji}" v-bind:datagaji="datagajidata"
                  v-on:showdataakun="showdatastaf" v-on:showdatapekerjaan="showdatapekerjaan"
                  v-on:postkaryawan="postkaryawan" v-on:showdetail="showdetail"/>
        <DetailKaryawan v-bind:class="{hidesection: !isdetail}" ref="detailkaryawanref" v-on:showkaryawanlist="showlist"
                        v-on:loadingpage=""/>
        <ImporAbsen v-if="isImportAbsen" v-on:showkaryawanlist="showlist"/>
        <RekapAbsen v-if="isRekapAbsen" v-on:showkaryawanlist="showlist" v-bind:datarekap="datarekap"
                    v-on:showdetailabsen="showdetailabsen" ref="rekapabsenref"
                    :periode_absen="periode_absen"
        />
        <DetailAbsen v-if="isDetailAbsen" v-on:showrekapabsen="showdatarekapabsen" v-bind:datarekapdetail="datarekapdetail"
                     v-bind:datarekap="datarekap" ref="detailabsenref"/>

        <div id="loadingPage" style="display: none">
            <span class="spinner-border spinner-border-sm-loader" role="status" aria-hidden="true"></span>
        </div>
    </div>
</template>

<script>
    import KaryawanList from "./KaryawanList";
    import CreateStaff from "./CreateStaff";
    import DataStaff from "./DataStaff";
    import DataPekerjaan from "./DataPekerjaan";
    import DataGaji from "./DataGaji";
    import DetailKaryawan from "./DetailKaryawan";
    import ImporAbsen from "./Absensi/ImporAbsen";
    import RekapAbsen from "./Absensi/RekapAbsen";
    import DetailAbsen from "./Absensi/DetailAbsen";

    export default {
        name: "Karyawan",
        components: {
            RekapAbsen,
            ImporAbsen,
            KaryawanList, CreateStaff, DataStaff, DataPekerjaan, DataGaji, DetailKaryawan,DetailAbsen,
        },
        data() {
            return {
                iskaryawanlist: false,
                iscreatestaff: false,
                isdatastaff: false,
                isdatapekerjaan: false,
                isdatagaji: false,
                isdetail: false,
                isImportAbsen:false,
                isRekapAbsen:false,
                isDetailAbsen:false,
                parentidkaryawan: '',

                datakaryawanlist: {
                    isClicked: false,
                    requestHeaders: {
                        headers: {
                            'Authorization': 'Bearer ' + localStorage.getItem('token'),
                        }
                    }
                },

                datacreatestaff: {
                    nama_karyawan: '',
                    telp_karyawan: '',
                    alamat_karyawan: '',
                    requestHeaders: {
                        headers: {
                            'Authorization': 'Bearer ' + localStorage.getItem('token'),
                        }
                    }
                },

                datastaffakun: {
                    username: '',
                    password: '',
                    confirm_password: '',
                    isClickedstaffakun: false,
                    requestHeaders: {
                        headers: {
                            'Authorization': 'Bearer ' + localStorage.getItem('token'),
                        }
                    }
                },

                datapekerjaandata: {
                    requestHeaders: {
                        headers: {
                            'Authorization': 'Bearer ' + localStorage.getItem('token'),
                        }
                    },
                    outlet: [],
                    optionoutlet: [],
                    workshop: [],
                    optionworkshop: [],
                    isClickeddatapekerjaan: false,
                    selected: '',
                    selectedworkshop: '',
                    datatahapan: [],
                    checklisttahapan: [],
                    dataProses: [],
                    dataCheckTahapan: [],
                    workChecked: [],
                    statusoutlet: '0',
                    statusworkshop: '0',
                    statuskurir: '0',
                },

                datagajidata: {
                    gajipokok: '',
                    uangmakan: '',
                    uanglembur: '',
                    gajiabsen: '',
                    uangtunjangan: '',
                    uangtransport: '',
                    datagajitemp: [],
                    isClickeddatagaji: false,
                    requestHeaders: {
                        headers: {
                            'Authorization': 'Bearer ' + localStorage.getItem('token'),
                        }
                    }
                },

                datadetail: {

                },

                dataimportabsensi:{

                },

                datarekap:{
                    idkaryawan:'',
                    filterby:'',
                    valuemonth:'',
                    valueyear:'',
                    valueawal:'',
                    valueakhir:'',
                },
                datarekapdetail: {

                },

	            periode_absen: {
		            filter_by: "",
		            start_date: "",
		            end_date: "",
		            month: "",
		            year: "",
	            }
            }
        },
        mounted() {
            this.showlist();
            this.smartTrackingView("list_karyawan_&_absensi");

        },

        methods: {
            resetData() {
                this.datacreatestaff = {
                    nama_karyawan: '',
                    telp_karyawan: '',
                    alamat_karyawan: '',
                    telp_code:'',
                    requestHeaders: {
                        headers: {
                            'Authorization': 'Bearer ' + localStorage.getItem('token'),
                        }
                    }
                }
                this.datastaffakun = {
                    username: '',
                    password: '',
                    confirm_password: '',
                    isClickedstaffakun: false,
                    requestHeaders: {
                        headers: {
                            'Authorization': 'Bearer ' + localStorage.getItem('token'),
                        }
                    }
                }

                this.datapekerjaandata = {
                    requestHeaders: {
                        headers: {
                            'Authorization': 'Bearer ' + localStorage.getItem('token'),
                        }
                    },
                    outlet: [],
                    optionoutlet: [],
                    workshop: [],
                    optionworkshop: [],
                    isClickeddatapekerjaan: false,
                    selected: '',
                    selectedworkshop: '',
                    datatahapan: [],
                    checklisttahapan: [],
                    dataProses: [],
                    dataCheckTahapan: [],
                    workChecked: [],
                    statusoutlet: '0',
                    statusworkshop: '0',
                    statuskurir: '0',
                }

                this.datagajidata = {
                    gajipokok: '',
                    uangmakan: '',
                    uanglembur: '',
                    gajiabsen: '',
                    uangtunjangan: '',
                    uangtransport: '',
                    datagajitemp: [],
                    isClickeddatagaji: false,
                    requestHeaders: {
                        headers: {
                            'Authorization': 'Bearer ' + localStorage.getItem('token'),
                        }
                    }
                }
            },

            showlist() {
                this.iskaryawanlist = true;
                this.iscreatestaff = false;
                this.isdatastaff = false;
                this.isdatapekerjaan = false;
                this.isdatagaji = false;
                this.isdetail = false;
                this.isImportAbsen = false;
                this.isRekapAbsen = false;
                this.isDetailAbsen = false;
                this.$refs.listkaryawan.getlistkaryawan(true);
                // this.$refs.listkaryawan.GetListAbsenDefault();
                this.$refs.listkaryawan.absenList(true);

                this.resetData();
            },

            // hashKaryawan(){
            //     this.$refs.listkaryawan.changeStatusTabsKaryawan();
            // },
            //
            // hashAbsensi(){
            //     this.$refs.listkaryawan.changeStatusTabsAbsensi();
            // },
            async skipOnboarding(params, data) {
                if (localStorage.getItem("step_walkthrough") !== undefined && localStorage.getItem("step_walkthrough") === "2"){
                    try {
                        const datawalkthrough = new FormData
                        datawalkthrough.append('walkthrough', params)
                        const response = await this.$axios.post(this.$baseurl + '/masterData/owner/update_status_walkthrough', datawalkthrough,{
                            headers: {
                                'Authorization': 'Bearer ' + localStorage.getItem('token'),
                            }
                        });
                        if (response.data.code === 200) {
                            if (response.data.status === true) {
                                localStorage.setItem("step_walkthrough", params)
                                this.showdetail(data)
                                setTimeout(() => {
                                    this.$refs.detailkaryawanref.onboardingFinishToDashboard();
                                }, 1000)
                            }
                        } else {
                            this.$toast.error(response.data.msg)
                        }
                    } catch (e) {
                        this.$catch_error_response(e)
                    }
                }else{
                    this.showdetail(data)
                }
            },
            async postkaryawan() {
                // return
                this.datagajidata.isClickeddatagaji = true;
                $('#btnNextGaji').prop('disabled', false);
                $('#textBtnGaji').hide();
                try {
                    var pekerjaan = this.datapekerjaandata.workChecked

                    var createdata = {
                        "nama": this.datacreatestaff.nama_karyawan,
                        "telp": this.datacreatestaff.telp_code + this.datacreatestaff.telp_karyawan,
                        "alamat": this.datacreatestaff.alamat_karyawan,
                        "email": this.datastaffakun.username,
                        "password": this.datastaffakun.confirm_password,
                        "status_karyawan_outlet": this.datapekerjaandata.statusoutlet,
                        "status_karyawan_kurir": this.datapekerjaandata.statuskurir,
                        "status_karyawan_workshop": this.datapekerjaandata.statusworkshop,
                        "karyawan_outlet_detail": {
                            "outlet_idoutlet": this.datapekerjaandata.selected
                        },
                        "karyawan_workshop_detail": {
                            "workshop_idworkshop": this.datapekerjaandata.selectedworkshop,
                            "pekerjaan": pekerjaan,
                        },
                        "gaji": this.datagajidata.datagajitemp
                    }
                    const res = await this.$axios.post(this.$baseurl + '/masterData/karyawan/create_karyawan', JSON.stringify(createdata), {
                        headers: {
                            'Content-type': 'application/json',
                            'Authorization': 'Bearer ' + localStorage.getItem('token'),
                        }
                    })

                    if (res.status === 200) {
                        if (res.data.status === true) {
                            // this.myChangeEventworkshop(this.myValue)
                            if(this.isWebview()) {
                                this.flutterNavigate('karyawan/settings/' + res.data.data.idkaryawan)
                                return
                            }
                            this.skipOnboarding(3, res.data.data.idkaryawan)
                            this.datagajidata.isClickeddatagaji = false
                            $('#btnNextGaji').prop('disabled', false);
                            $('#textBtnGaji').show();
                            this.datacreatestaff.nama_karyawan = '';
                            this.datacreatestaff.telp_karyawan = '';
                            this.datacreatestaff.alamat_karyawan = '';
                            this.datastaffakun.username = '';
                            this.datastaffakun.password = '';
                            this.datastaffakun.confirm_password = '';
                            this.datapekerjaandata.statusoutlet = '0';
                            this.datapekerjaandata.statuskurir = '0';
                            this.datapekerjaandata.statusworkshop = '0';
                            this.datapekerjaandata.selected = [];
                            this.datapekerjaandata.selectedworkshop=[];
                            this.datapekerjaandata.dataCheckTahapan = [];
                            this.datapekerjaandata.dataProses = []
                            this.datapekerjaandata.checklisttahapan = []
                            this.datagajidata.datagajitemp = [];
                            $(".formgaji").val("");
                            this.datapekerjaandata.workChecked = [];
                            // this.$router.push({name: 'detailkaryawan', params: {idkaryawan: res.data.data.idkaryawan}})
                            $('#contentoutlet').slideUp(400);
                            $('#outlet').prop('checked', false)
                            $('#contentworkshop').slideUp(400);
                            $('#workshop').prop('checked', false)
                            $('#content-kasir').slideUp(400);
                            $('#kurir').prop('checked', false)
	                        this.$toast.success(res.data.msg)
                        } else {
                        	this.$toast.error(res.data.msg)
                            this.datagajidata.isClickeddatagaji = false
                            $('#btnNextGaji').prop('disabled', false);
                            $('#textBtnGaji').show();
                        }
                    }
                } catch (e) {
                	this.$catch_error_response(e)
                    console.log(e);
	                this.datagajidata.isClickeddatagaji = false
	                $('#textBtnGaji').show()
	                $('#btnNextGaji').prop('disabled', false);
                }
            },

            showcreatestaff() {
                this.iskaryawanlist = false;
                this.iscreatestaff = true;
                this.isdatastaff = false;
                this.isdatapekerjaan = false;
                this.isdatagaji = false;
                this.isImportAbsen = false;
                this.isRekapAbsen = false;
                this.isDetailAbsen = false;
            },
            showdatastaf() {
                this.iskaryawanlist = false;
                this.iscreatestaff = false;
                this.isdatastaff = true;
                this.isdatapekerjaan = false;
                this.isdatagaji = false;
                this.isImportAbsen = false;
                this.isRekapAbsen = false;
                this.isDetailAbsen = false;
            },
            showdatapekerjaan() {
                this.iskaryawanlist = false;
                this.iscreatestaff = false;
                this.isdatastaff = false;
                this.isdatapekerjaan = true;
                this.isdatagaji = false;
                this.isImportAbsen = false;
                this.isRekapAbsen = false;
                this.isDetailAbsen = false;

                this.$refs.datapekerjaanref.listoutlet()
                this.$refs.datapekerjaanref.getWorkshop()
            },


            showdatagaji() {
                this.iskaryawanlist = false;
                this.iscreatestaff = false;
                this.isdatastaff = false;
                this.isdatapekerjaan = false;
                this.isdatagaji = true;
                this.isImportAbsen = false;
                this.isRekapAbsen = false;
                this.isDetailAbsen = false;
            },

            showdetail(idkaryawan) {
                this.iskaryawanlist = false;
                this.iscreatestaff = false;
                this.isdatastaff = false;
                this.isdatapekerjaan = false;
                this.isdatagaji = false;
                this.isdetail = true;
                this.isImportAbsen = false;
                this.isRekapAbsen = false;
                this.isDetailAbsen = false;
                this.$refs.detailkaryawanref.setid(idkaryawan)
	            this.backButtonPressed(this.$refs.detailkaryawanref.back)
            },

            showdataimporabsen() {
                this.iskaryawanlist = false;
                this.iscreatestaff = false;
                this.isdatastaff = false;
                this.isdatapekerjaan = false;
                this.isdatagaji = false;
                this.isImportAbsen = true;
                this.isRekapAbsen = false;
                this.isDetailAbsen = false;

            },

            showdatarekapabsen(data) {
                this.smartTrackingClick("detail_rekap_absensi",{"idkaryawan":data.idkaryawan});

                this.iskaryawanlist = false;
                this.iscreatestaff = false;
                this.isdatastaff = false;
                this.isdatapekerjaan = false;
                this.isdatagaji = false;
                this.isImportAbsen = false;
                this.isRekapAbsen = true;
                this.isDetailAbsen = false;
                this.datarekap.idkaryawan =data.idkaryawan;
                this.datarekap.filterby =data.filterby;
                this.datarekap.valueyear=data.valueyear;
                this.datarekap.valuemonth=data.valuemonth;
                this.datarekap.valueawal=data.valueawal;
                this.datarekap.valueakhir=data.valueakhir;

                setTimeout(() => {
	                this.backButtonPressed(this.$refs.rekapabsenref.back)
                },300)
            },

            showdetailabsen(data){
                this.iskaryawanlist = false;
                this.iscreatestaff = false;
                this.isdatastaff = false;
                this.isdatapekerjaan = false;
                this.isdatagaji = false;
                this.isImportAbsen = false;
                this.isRekapAbsen = false;
                this.isDetailAbsen = true;
                this.datarekapdetail=data;
	            setTimeout(() => {
		            this.backButtonPressed(this.$refs.detailabsenref.backrekapabsen)
	            },300)
            },
        }
    }
</script>

<style scoped>
    .hidesection {
        display: none;
    }

    .edit {

    }

    .alert-custome {
        background: #FCF4D9;
        box-shadow: 0px 12px 24px rgba(0, 0, 0, 0.07);
        border-radius: 3px;
        border: 1px solid #F6BC88;
    }
</style>